import LegacyContentConfig from './LegacyContentConfig';
import setVar from './util/setVar';
import { Bitrates } from './interfaces';

export function setPriority(
  obj?: PlaybackSectionConfig,
  config?: LegacyContentConfig
): string {
  if (obj && obj.priority) {
    return obj.priority;
  }
  if (config && config.b && config.t && !config.ch) {
    return 't';
  }
  return '';
}

export default class PlaybackSectionConfig implements Bitrates {
  priority: string;
  blackout?: boolean;
  delay?: number;
  minVideoBitrate?: number;
  maxVideoBitrate?: number;
  minAudioBitrate?: number;
  maxAudioBitrate?: number;

  constructor(obj?: PlaybackSectionConfig, config?: LegacyContentConfig) {
    // TODO: possible bug here.....

    this.priority = setPriority(obj, config); // && obj.priority) || 't'; // If no playback priority default to ten
    this.blackout = setVar(false, obj && obj.blackout);
    this.delay = obj && obj.delay;
    this.minVideoBitrate = obj && obj.minVideoBitrate;
    this.maxVideoBitrate = obj && obj.maxVideoBitrate;
    this.minAudioBitrate = obj && obj.minAudioBitrate;
    this.maxAudioBitrate = obj && obj.maxAudioBitrate;
  }
}
